import { get } from "lodash";

const getFieldValue = (item, fieldName) => {
  return (
    (item &&
      item.fields &&
      item.fields[fieldName] &&
      item.fields[fieldName].value) ||
    ''
  );
};
export const preProcessData = (ticket, stripColor, backgroundColor) => {
  const editorialGridTabs = [];
  ticket &&
    ticket.length > 0 &&
    ticket.forEach(item => {

      editorialGridTabs.push({
        fields: {
          stripColor: {
            fields: {
              colorCode: {
                value: stripColor || 'blue',
              },
            },
          },
          backgroundColor: {
            fields: {
              colorCode: {
                value: backgroundColor || 'LightGrey',
              },
            },
          },
          title: {
            value: getFieldValue(item, 'ticketTitle'),
          },
          imageTextLink: {
            value: {
              href: get(getFieldValue(item, 'ticketWebUrl'), "href", ""),
              linktype: get(getFieldValue(item, 'ticketWebUrl'), "linktype", ""),
              target: get(getFieldValue(item, 'ticketWebUrl'), "target", ""),
              class: "",
            },
          },
          subTitle: {
            value:
              getFieldValue(item, 'ticketCurrency') +
              ' ' +
              getFieldValue(item, 'ticketPrice'),
          },
        },
      });
    });
  return editorialGridTabs;
};